import { defineCustomElement } from '@tyler-components-web/core';
import { IconComponent } from './icon';
import { TylerIconRegistry } from './icon-registry';
import { TYLER_ICON_REGISTRY_KEY } from './icon-constants';
export * from './icon-adapter';
export * from './icon-constants';
export * from './icon-foundation';
export * from './icon-registry';
export * from './icon-utils';
export * from './icon';
export function defineIconComponent() {
    defineCustomElement(IconComponent);
}
// Store a reference to the icon registry on `window`.
if (window && !window[TYLER_ICON_REGISTRY_KEY]) {
    window[TYLER_ICON_REGISTRY_KEY] = TylerIconRegistry;
}
